$(document).ready(function(){
  $(".reviews--slider").slick({
    "arrows": true,
    "accessibility": true,
    "prevArrow":"<button type='button' class='slick-prev'><span class='visually-hidden'>Produktvorschau zurück</span><svg width='105' height='105' viewBox='0 0 105 105' fill='none' xmlns='http://www.w3.org/2000/svg'><g filter='url(#filter0_d_251_983)'><circle cx='52.5' cy='48.5' r='48.5' transform='rotate(180 52.5 48.5)' fill='black'/></g><path d='M57.9343 85.1707L62.5289 80.5761L33.6156 51.6627L77.6585 51.6627L77.6584 45.1651L33.6156 45.1651L62.5289 16.2518L57.9343 11.6572L21.1776 48.4139L57.9343 85.1707Z' fill='white'/><defs><filter id='filter0_d_251_983' x='4.19617e-05' y='0' width='105' height='105' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/><feOffset dy='4'/><feGaussianBlur stdDeviation='2'/><feComposite in2='hardAlpha' operator='out'/><feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/><feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_251_983'/><feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_251_983' result='shape'/></filter></defs></svg></button>",
    "nextArrow":"<button type='button' class='slick-next'><span class='visually-hidden'>nächste Kundenmeinung</span><svg width='131' height='132' viewBox='0 0 131 132' fill='none' xmlns='http://www.w3.org/2000/svg'><g filter='url(#filter0_d_3275_2)'><circle cx='65.5' cy='62' r='61.5' fill='black'/></g><path d='M58.6091 15.5L52.7829 21.3262L89.4463 57.9895L33.598 57.9895L33.5981 66.2288L89.4463 66.2287L52.7829 102.892L58.6091 108.718L105.218 62.1091L58.6091 15.5Z' fill='white'/><defs><filter id='filter0_d_3275_2' x='0' y='0.5' width='131' height='131' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/><feOffset dy='4'/><feGaussianBlur stdDeviation='2'/><feComposite in2='hardAlpha' operator='out'/><feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/><feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3275_2'/><feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_3275_2' result='shape'/></filter></defs></svg></button>"
  });

  $(".collection--slider > ul").slick({
    "slidesToShow": 2,
    "slidesToScroll": 1,
    "arrows": true,
    "accessibility": true,
    "centermode": false,
    "infinite": false,
    "prevArrow":"<button type='button' class='slick-prev'><span class='visually-hidden'>Produktvorschau zurück</span><svg width='105' height='105' viewBox='0 0 105 105' fill='none' xmlns='http://www.w3.org/2000/svg'><g filter='url(#filter0_d_251_983)'><circle cx='52.5' cy='48.5' r='48.5' transform='rotate(180 52.5 48.5)' fill='black'/></g><path d='M57.9343 85.1707L62.5289 80.5761L33.6156 51.6627L77.6585 51.6627L77.6584 45.1651L33.6156 45.1651L62.5289 16.2518L57.9343 11.6572L21.1776 48.4139L57.9343 85.1707Z' fill='white'/><defs><filter id='filter0_d_251_983' x='4.19617e-05' y='0' width='105' height='105' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/><feOffset dy='4'/><feGaussianBlur stdDeviation='2'/><feComposite in2='hardAlpha' operator='out'/><feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/><feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_251_983'/><feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_251_983' result='shape'/></filter></defs></svg></button>",
    "nextArrow":"<button type='button' class='slick-next'><span class='visually-hidden'>Produktvorschau vorwärts</span><svg width='131' height='132' viewBox='0 0 131 132' fill='none' xmlns='http://www.w3.org/2000/svg'><g filter='url(#filter0_d_3275_2)'><circle cx='65.5' cy='62' r='61.5' fill='black'/></g><path d='M58.6091 15.5L52.7829 21.3262L89.4463 57.9895L33.598 57.9895L33.5981 66.2288L89.4463 66.2287L52.7829 102.892L58.6091 108.718L105.218 62.1091L58.6091 15.5Z' fill='white'/><defs><filter id='filter0_d_3275_2' x='0' y='0.5' width='131' height='131' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'><feFlood flood-opacity='0' result='BackgroundImageFix'/><feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/><feOffset dy='4'/><feGaussianBlur stdDeviation='2'/><feComposite in2='hardAlpha' operator='out'/><feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'/><feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3275_2'/><feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_3275_2' result='shape'/></filter></defs></svg></button>",
    "responsive": [
      {
        "breakpoint": 991,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1,
        }
      }
    ]
  });

  $('input[type=checkbox]').keypress(function (e) {
   var key = e.which;
   if(key == 13)  // the enter key code
    {
      $('input[type=checkbox]').click();
      return false;  
    }
  });  

  $(".tl-switcher .tl-option, .tl-select").attr('tabindex', '0');
  function addTabIndex(){
    $(".gpo-checkbox").attr('tabindex', '0');

    $( ".gpo-checkbox" ).keypress(function (e) {
      if(e.key === "Enter") {
        e.preventDefault();
        $(this).find("input").click();
      }
    });
  };

  window.setTimeout( addTabIndex, 3000 );

  var select = document.querySelector("#lang-des .tl-select");
  select.addEventListener("keypress", function(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      select.click();
    }
  });

  var options = document.querySelectorAll("#lang-des .tl-option");

  [].forEach.call(options, function(option) {
    option.addEventListener("keypress", function(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        option.click();
      }
    });
  });

  
  $('.form-popup').on($.modal.OPEN, function(event, modal) {
    $(event.target).attr('tabindex', '0');
    $(event.target).focus();
  });

  $('.video--play').on('click', function() {
    var url = $(this).data('id');
    var iframe = $('#vidpop');
    var iframeel = $('#videopopup');
    var close = $('#vidpop a');

    if(url != "") {

      // change the video source with the clicked one
      $(iframeel).attr('src', '');
      $(iframeel).attr('src', url);
      $(iframeel).click();
      setTimeout(function(){
        $(iframeel).focus();
        $(iframe).focus();
      }, 0);
                 
      $(document).on('click', function(e) {
        if($(iframe).is(e.target) || $(close).is(e.target)) {
          //$(iframeel).attr('src', '');
        }
      });
    }
  });

  $('.vidpop').on($.modal.BEFORE_CLOSE, function(event, modal) {
    $('.vidpop video').attr("src", "");
  });

  $('.vidpop').on($.modal.OPEN, function(event, modal) {
    $(this).children('video').focus();
  });

  $(window).resize(function() {
    if (document.documentElement.clientWidth < 749) {    
        $('#product-grid').slick({
          dots: true,
          infinite: false,
          accessibility: true,
          centermode: false,
          slidesToShow: 1,
          slidesToScroll: 1
      });
    }
  }).resize()
    
  $('body').on('click', '[name="checkout"]', function() {
    if ($(this).parent().siblings('.cart__bottom').find('.agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });

  $('.modal').on($.modal.OPEN, function(event, modal) {
    $(this).find('#ContactForm-name').focus();
  });

  $('.modal').on($.modal.BEFORE_CLOSE, function(event, modal) {
    $(this).find('#ContactForm-name').blur();
  });
})